<template>
  <div class="blog-detail">
    <div class="container">
    <div class="vld-parent">
        <loading :active.sync="isLoading"
        :can-cancel="true"
        :on-cancel="onCancel"
        :is-full-page="fullPage"></loading>
    </div>           
      <transition name="fade">
        <div class="blog-share" v-show="showShare">
          <social-share :socials="socials" :title="title" :url="url" :twitter_user="twitter_user" :description="description"/>
        </div>
      </transition>

      <div class="mobileTab">
        <v-select placeholder="Select Category" :options="links" @onselect="selectCategory"/>
      </div>
          <div slot="bread">
<ol itemscope itemtype="http://schema.org/BreadcrumbList">
<li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/" class="" itemtype="https://schema.org/Thing" itemprop="item">
<span itemprop="name">holywoodskyline.com</span>
<span> / </span>
</a>
<meta itemprop="position" content="1" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a href="/blog" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name">Blog</span>
</a>
<meta itemprop="position" content="2" />
</li>
<li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
<a :href="url" class="" itemtype="https://schema.org/Thing" itemprop="item">
&nbsp;<span itemprop="name"> {{ blog.title }}</span>
</a>
<meta itemprop="position" content="3" />
</li>
</ol>

          </div>
            <div>
             <p>&nbsp;</p>         
             </div>   
      <div class="row">
        <div ref="detailContent" class="blog-detail-gen col-xs-12 col-md-9">
          <h1 class="blog-detail__title" v-if="blog">{{ blog.title }}</h1>
          <div class="blog-card-inf" v-if="blog">
            <span class="blog-card-inf__icon">
              <svg-icon type="icon-user"/>
            </span>
            <div class="blog-card-inf__title">{{ blog.author }}</div>
            <p class="blog-detail__date">{{ blog.publishedAt }}</p>
            <div>
            <p>&nbsp;</p>
             <p>&nbsp;</p>  
              <p>&nbsp;</p>        
             </div>
          </div>
          <div v-if="blog && blog.cover" class="blog-detail__img">
            <img :src="blog.cover" alt="">
          </div>
          <div class="static-content blog-text" v-if="blog && blog.content && blog.content != 'null'" v-html="blog.content"></div>
          <a :href="blog.url" class="" itemtype="https://schema.org/Thing" itemprop="item">
          Read teh full article
          <span itemprop="name">{{blog.url}}</span>
          <span> / </span>
          </a>
          <div v-if="blog.content === '' || blog.content === 'null'" class="result-bracket__title">
            <empty-content :content="emptyContent"/>
          </div>


      <div class="clearfix"></div> 
            <div class="blogShareWrapper">
             <transition name="fade">
                <div class="blog-share">
                 <span class="share-text">
                  Share:
              </span>
            <social-share :socials="socials" :title="title" :url="url" :twitter_user="twitter_user" :description="description"/>
          </div>
        </transition>
      </div>
      <div>

            <div class="clearfix"></div>  
             </div>
<!--             <div class="dorm-gallery" v-if="blog && blog.images.length > 0" >
            <div class="gallery">
             <GalleryThumb :gallery="blog.images" v-if="blog.images.length > 0" />
                  <div class="dorm-gallery-empty" v-if="blog.images.length === 0 || !blog.images">
                        <img src="@/assets/img/holywoodskyline-default.jpg" alt="" class="dorm-gallery-empty__img">
                  </div>
            </div>
          </div>  -->
        </div>

        <div class="right-bar col-xs-12 col-md-3 ">
          <div class="right-bar__wrapper DesktopTab">
            <h2>Categories</h2>
            <div v-if="links" class="right-bar__category">
              <div class="right-bar__category--item mypointer" v-for="link in links" :key="link.id">
                <span class="icon-font-arrow">
                  <svg-icon type="icon-arrow-long-right"/>
                </span>
                <span v-on:click="selectCategory(link)" class="btn-txt">
                  {{ link.title }}
                </span>
              </div>
            </div>
          </div>
<!--           <div class="right-bar__wrapper" style="padding: 0;background-color: transparent;box-shadow: none">
            <AdvertBanner :dorms="dorms"/>
          </div> -->
        </div>
      </div>

      <div v-if="dorms" class="section__header">
        <div class="section__title">
          <span class="color-light-green">Recommended</span> Movies
        </div>
      </div>
      <div class="dorm-tab__list" v-if="dorms" style="display: flex;">
        <div
          v-for="dorm in dorms"
          :key="dorm.id"
          class="dorm-tab__col col-xl-4 col-lg-4 col-md-4">
          <movie-card
            :movie="dorm"
          />
        </div>
      </div>
                <div v-if="blogs && blogs.length > 0" class="city-uni dorm-slider" ref="dormSlider">
                    <container>
                        <div class="city-uni__wrp">
                            <div class="section__header">
                                <div class="section__title">
                                    <span class="color-light-green">Similar</span> Articles
                                </div>
                                <div class="section__right">
                                    <v-button icon="icon-arrow-left" icon-position="left" class="circle white icon-xs xs js-uni-slider-prev" />

                                    <v-button icon="icon-arrow-right" icon-position="left" class="circle white icon-xs xs js-uni-slider-next" />
                                </div>
                            </div>
                            <swiper class="city-uni-slider" :options="swiperOption">
                                <swiper-slide v-for="dorm in blogs" :key="dorm.id" class="city-uni-slider__item">
                                    <BlogCard2 :dorm="dorm" />
                                </swiper-slide>
                            </swiper>
                        </div>
                    </container>
                </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import SocialShare from '@/components/blogShare/SocialShare'
import AdvertBanner from '@/components/AdvertBanner'
import MovieCard from '@/components/MovieCard'
import BlogCard from '@/components/Blog/BlogCard'
import SelectBox from '@/components/SelectBox'
import axios from 'axios'
import GalleryThumb from '@/components/GalleryThumb'
import EmptyContent from '@/components/EmptyContent'
import BlogCard2 from '@/components/Blog/BlogCard2'
import { SET_BLOG_CATEGORY_TITLE, SET_BLOG_CATEGORY_SLUG } from '@/store/mutations.type'
import Loading from 'vue-loading-overlay'
export default {
  name: 'BlogDetail',
  components: {
    SocialShare, AdvertBanner, MovieCard, SelectBox, GalleryThumb, EmptyContent, BlogCard2, Loading
  },
   metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.blog ? this.blog.title : '',
      meta: [
        { name: 'description', content: this.meta_description },
        { name: 'keywords', content: this.meta_keywords }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.$route.fullPath }
      ]
    }
  }, 
  data () {
    return {
      blogDetails: null,
      isLoading: false,
      swiperOption: {
        slidesPerView: 3,
        speed: 500,
        spaceBetween: 20,
        breakpoints: {
          768: {
            slidesPerView: 2,
            centeredSlides: false,
            slidesPerGroup: 2
          },
          640: {
            slidesPerView: 1,
            centeredSlides: false,
            slidesPerGroup: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.js-uni-slider-next',
          prevEl: '.js-uni-slider-prev'
        }
      },     
      blogs: [],
      emptyContent: {
        icon: 'icon-search',
        title: 'İçerik Bulunamadı!',
        text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda dolor, dolorem fugit in quis velit!'
      },      
      blog_url: '',
      blog_title: '',
      blog_slug: '',
      blog_content: '',
      url: '',
      twitter_user: '',
      title: '',
      description: '',
      showShare: true,
      categories: [
                {
created_at: "2019-03-15 23:48:02",
id: 1,
slug: "hollywood",
sort: null,
title: "Hollywood",
updated_at: "2019-03-20 10:54:56"          
        },
        {
created_at: "2019-03-15 23:48:02",
id: 1,
slug: "filmstudios",
sort: null,
title: "Film Studios",
updated_at: "2019-03-20 10:54:56"          
        },
        {
created_at: "2019-03-15 23:48:02",
id: 1,
slug: "netflix",
sort: null,
title: "Netflix",
updated_at: "2019-03-20 10:54:56"          
        }
      ],
      links: [],
      socials: [
        {
          id: 0,
          icon: 'icon-facebook',
          link: '#',
          network: 'facebook'
        },
        {
          id: 1,
          icon: 'icon-twitter',
          link: '#',
          network: 'twitter'
        },
        {
          id: 2,
          icon: 'icon-linkedin',
          link: '#',
          network: 'linkedin'
        },
        {
          id: 3,
          icon: 'icon-whatsapp',
          link: '#',
          network: 'whatsapp'
        }
      ],
      dorms: null,
      details: null,
      blog: null,
      meta_description: '',
      meta_keywords: '',
      errors: []
    }
  },
  methods: {
    selectCategory(opt) {
      this.$store.commit(SET_BLOG_CATEGORY_TITLE, opt.title )
      this.$store.commit(SET_BLOG_CATEGORY_SLUG, opt.value )
      this.$router.push('/blog/kategori/' + opt.value)
    },
    goLink (link) {
      this.$router.push('/blog/kategori/' + link.value)
    },
    handleScroll () {
      let scrollY = window.scrollY
      let contentHeight = this.$refs.detailContent.offsetHeight
      this.showShare = scrollY <= contentHeight
    },
    getBLogDetails () {
      let self = this
      this.isLoading = true
      const yesterday = new Date(Date.now() - 1 * 86400000 - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0]
      axios({ url: `everything?q=hollywood&from=${yesterday}&sortBy=publishedAt&apiKey=e34edc1310254cb789cc1c918c5f88c7`, baseURL: 'http://newsapi.org/v2/' })
        .then(response => {
          self.isLoading = false
          self.blog = response.data.articles.find((city) => city.title == this.$route.params.title)
          self.description = self.blog.description
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    getCategories () {
         this.links = this.categories
          this.links.forEach((item) => {
              item.name = item.title,
              item.value = item.slug
            })
    },
    getBlogs () {
      let self = this
      axios.get(`/site/blogs/category/${this.blog.category.slug}`)
        .then(response => {
                    response.data.blogs.forEach((item) => {
            if (item.id != self.blog.id) {
              self.blogs.push(item)
            }
          })
        })
        .catch(e => {
          this.errors.push(e)
        })
    },    
  },
  computed: {
    generateDate () {
      let date = new Date(this.blog.created_at)
      return date.toLocaleDateString()
    }
  },
  created () {
    this.getBLogDetails()
    this.getCategories()
    //this.getBlogs()
    //window.addEventListener('scroll', this.handleScroll)
    const host = window.location.origin
    this.url = window.location.origin + this.$route.fullPath  
    this.twitter_user = window.localStorage.getItem('first_name') + window.localStorage.getItem('last_name')
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    //this.getCategories()
  }
}
</script>

<style lang="scss">
  @import "../assets/scss/components/blog-detail";
  @import "../assets/scss/components/dorm-detail";
  .mypointer {
    cursor: pointer;
  }
</style>
